import { toDecimal, roundValue } from "src/util/decimal-utils";

export const getRevisedProjectTotal = ({ sectionProjectTotal, optionProjectTotal }) => {
    const revisedProjectTotal = {
        materialCost: 0.00,
        laborCost: 0.00,
        subcontractorCost: 0.00,
        materialSaleAmount: 0.00,
        laborSaleAmount: 0.00,
        subcontractorSaleAmount: 0.00,
        totalSaleAmount: 0.00,
        totalCost: 0.00,
        materialProfit: 0.00,
        laborProfit: 0.00,
        subcontractorProfit: 0.00,
        totalProfit: 0.00,
        materialProfitPercentage: 0.00,
        laborProfitPercentage: 0.00,
        subcontractorProfitPercentage: 0.00,
        totalProfitPercentage: 0.00,
        percentageComplete: 0.00,
        forecastHours: 0.00,
        actualHours: 0.00,
        taskCount: 0
    };

    const toPercent = (profit, cost) => cost !== 0 ? (profit / cost) * 100 : 0.00;

    // Use Decimal.js for all additions to avoid floating-point precision errors
    revisedProjectTotal.materialCost = roundValue(
        toDecimal(sectionProjectTotal.materialCost || 0).plus(toDecimal(optionProjectTotal.materialCost || 0))
    );
    revisedProjectTotal.laborCost = roundValue(
        toDecimal(sectionProjectTotal.laborCost || 0).plus(toDecimal(optionProjectTotal.laborCost || 0))
    );
    revisedProjectTotal.subcontractorCost = roundValue(
        toDecimal(sectionProjectTotal.subcontractorCost || 0).plus(toDecimal(optionProjectTotal.subcontractorCost || 0))
    );
    revisedProjectTotal.totalCost = roundValue(
        toDecimal(sectionProjectTotal.totalCost || 0).plus(toDecimal(optionProjectTotal.totalCost || 0))
    );

    revisedProjectTotal.materialSaleAmount = roundValue(
        toDecimal(sectionProjectTotal.materialSaleAmount || 0).plus(toDecimal(optionProjectTotal.materialSaleAmount || 0))
    );
    revisedProjectTotal.laborSaleAmount = roundValue(
        toDecimal(sectionProjectTotal.laborSaleAmount || 0).plus(toDecimal(optionProjectTotal.laborSaleAmount || 0))
    );
    revisedProjectTotal.subcontractorSaleAmount = roundValue(
        toDecimal(sectionProjectTotal.subcontractorSaleAmount || 0).plus(toDecimal(optionProjectTotal.subcontractorSaleAmount || 0))
    );
    revisedProjectTotal.totalSaleAmount = roundValue(
        toDecimal(sectionProjectTotal.totalSaleAmount || 0).plus(toDecimal(optionProjectTotal.totalSaleAmount || 0))
    );

    revisedProjectTotal.materialProfit = roundValue(
        toDecimal(sectionProjectTotal.materialProfit || 0).plus(toDecimal(optionProjectTotal.materialProfit || 0))
    );
    revisedProjectTotal.laborProfit = roundValue(
        toDecimal(sectionProjectTotal.laborProfit || 0).plus(toDecimal(optionProjectTotal.laborProfit || 0))
    );
    revisedProjectTotal.subcontractorProfit = roundValue(
        toDecimal(sectionProjectTotal.subcontractorProfit || 0).plus(toDecimal(optionProjectTotal.subcontractorProfit || 0))
    );
    revisedProjectTotal.totalProfit = roundValue(
        toDecimal(sectionProjectTotal.totalProfit || 0).plus(toDecimal(optionProjectTotal.totalProfit || 0))
    );

    // Calculate task-weighted average for completion
    const sectionTasksCount = sectionProjectTotal.taskCount || 0;
    const optionTasksCount = optionProjectTotal.taskCount || 0;
    const totalCount = sectionTasksCount + optionTasksCount;

    if (totalCount > 0) {
        // sum = average * count
        const sectionPercentageSum = toDecimal(sectionProjectTotal.percentageComplete || 0).times(sectionTasksCount);
        const optionPercentageSum = toDecimal(optionProjectTotal.percentageComplete || 0).times(optionTasksCount);
        
        revisedProjectTotal.percentageComplete = roundValue(
            sectionPercentageSum.plus(optionPercentageSum).dividedBy(totalCount)
        );
        revisedProjectTotal.completionPercentage = `${roundValue(revisedProjectTotal.percentageComplete, 0)}%`;
        revisedProjectTotal.taskCount = totalCount;
    }

    revisedProjectTotal.forecastHours = roundValue(
        toDecimal(sectionProjectTotal.forecastHours || 0).plus(toDecimal(optionProjectTotal.forecastHours || 0))
    );
    revisedProjectTotal.actualHours = roundValue(
        toDecimal(sectionProjectTotal.actualHours || 0).plus(toDecimal(optionProjectTotal.actualHours || 0))
    );

    if (totalCount > 0) {
        revisedProjectTotal.materialProfitPercentage = toPercent(revisedProjectTotal.materialProfit, revisedProjectTotal.materialCost);
        revisedProjectTotal.laborProfitPercentage = toPercent(revisedProjectTotal.laborProfit, revisedProjectTotal.laborCost);
        revisedProjectTotal.subcontractorProfitPercentage = toPercent(revisedProjectTotal.subcontractorProfit, revisedProjectTotal.subcontractorCost);
        revisedProjectTotal.totalProfitPercentage = toPercent(revisedProjectTotal.totalProfit, revisedProjectTotal.totalCost);
    }

    return revisedProjectTotal;
}